module.exports = __webpack_public_path__ + "static/media/Drug Addiction.b7c0dda0.svg";